/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutPrint.vue?vue&type=template&id=dd85c3c0"
import script from "./LayoutPrint.vue?vue&type=script&lang=ts"
export * from "./LayoutPrint.vue?vue&type=script&lang=ts"
import style0 from "./LayoutPrint.vue?vue&type=style&index=0&id=dd85c3c0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports